import { useMemo, memo, useRef, useEffect } from 'react'
import { OrdersDataType } from '../../reducer/orders.reducer'
import { useSelector } from 'react-redux'
import { selectOrdersData } from '../../selectors/orders'

type Props = {
    fillColor: string
    order: OrdersDataType
    i: number,
    numberOfReadOnlyOrders: number
    squaredOff: boolean
    position: boolean
}

export const redFill = 'rgba(224, 72, 76, 0.35)'
export const greenFill = 'rgba(82, 168, 149, 0.35)'

export const red = 'rgba(224, 72, 76, 1)'
export const green = 'rgba(82, 168, 149, 1)'

const OrderSlider = ({ fillColor, order, i, numberOfReadOnlyOrders, squaredOff = false, position }: Props) => {
    const { hoveredOrderIndex } = useSelector(selectOrdersData)
    const svgRef = useRef<SVGSVGElement>(null)
    const fillColorSolid = useMemo(() => {
        return order.type === 'buy' ? green : red
    }, [order.type])

    useEffect(() => {
        if (hoveredOrderIndex?.includes(i - numberOfReadOnlyOrders)) {
            if (svgRef.current) svgRef.current.style.transform = "scale(1.4)"
        } else {
            if (svgRef.current) svgRef.current.style.transform = "scale(1)"
        }
    }, [hoveredOrderIndex, i, numberOfReadOnlyOrders])
    return (
        <svg ref={svgRef} xmlns="http://www.w3.org/2000/svg" style={{
            transition: "transform 0.2s ease",
            transformOrigin: "top"
        }} width="30" height={`${45 + i * 10}`} viewBox="0 0 110 160" fill="none">
            <line x1={55} x2={55} y1={-68.97} y2={1.38} stroke={fillColor} strokeWidth={5} strokeDasharray={`${10},${3}`} />
            <path fillRule="evenodd" strokeDasharray={6} stroke={squaredOff ? fillColorSolid : 'none'} strokeWidth={squaredOff ? 4 : 0} fill={fillColorSolid} fillOpacity={squaredOff ? "0.3" : "0.9"} clipRule="evenodd" d="M100 157H11C10.4477 157 10 156.552 10 156V50.3064C10 49.7834 10.2048 49.2813 10.5706 48.9075L54.7853 3.73024C55.1775 3.32951 55.8225 3.32951 56.2147 3.73024L100.429 48.9075C100.795 49.2813 101 49.7834 101 50.3064V156C101 156.552 100.552 157 100 157Z" />
            <text className="font-feature-num" fill={'white'} x={55} y={position ? 135 : 115} fontWeight={500} fontSize={50} textAnchor="middle">
                {order.quantity}
            </text>
            {
                position ?
                    <path d="M58.8 56.9474V53.4737H52.2V56.9474H58.8ZM42.3 62.1579V77.7895C42.3 78.7447 43.0425 79.5263 43.95 79.5263H67.05C67.9575 79.5263 68.7 78.7447 68.7 77.7895V62.1579C68.7 61.2026 67.9575 60.4211 67.05 60.4211H43.95C43.0425 60.4211 42.3 61.2026 42.3 62.1579ZM68.7 56.9474C70.5315 56.9474 72 58.4932 72 60.4211V79.5263C72 81.4542 70.5315 83 68.7 83H42.3C40.4685 83 39 81.4542 39 79.5263L39.0165 60.4211C39.0165 58.4932 40.4685 56.9474 42.3 56.9474H48.9V53.4737C48.9 51.5458 50.3685 50 52.2 50H58.8C60.6315 50 62.1 51.5458 62.1 53.4737V56.9474H68.7Z" fill="white" />
                    : null
            }
        </svg>
    )
}

export default memo(OrderSlider)
